<app-table
    [data]="trainingGroupsQualificationData"
    [columns]="trainingGroupsQualificationColumns"
    (onRowClick)="onTrainingGroupClick($event)"
></app-table>